export default class Navbar {
  constructor() {
    this.loginButton = document.querySelector('.js-login-button');
    this.loginDropdown = document.querySelector('.js-login-dropdown');
    this.mobileButtons = document.querySelectorAll('.js-mobile-button');
    this.navbar = document.querySelector('.js-navbar');
    this.fullScreenMenu = document.querySelector('.js-full-screen-menu');
    this.dropdownLinks = document.querySelectorAll('.js-menu-item-has-children');
    this.dropdownLinksParents = document.querySelectorAll('.js-dropdown-menu-parent');
    this.dropdownMenus = document.querySelectorAll('.js-dropdown-menu');
    this.overlay = document.querySelector('.js-overlay');
    this.navbarBottom = document.querySelector('.js-navbar-bottom-desktop');
    this.menuLinks = document.querySelectorAll('.js-menu-item');
    this.backButton = document.querySelector('.js-back-button');
    this.openButton = document.querySelector('.js-open-button');
    this.closeButton = document.querySelector('.js-close-button');

    // Save references to bound event handlers to be able to remove them later
    this.boundShowLoginDropdown = this.showLoginDropdown.bind(this);
    this.boundHideLoginDropdown = this.hideLoginDropdown.bind(this);
    this.boundToggleFullScreenMenu = this.toggleFullScreenMenu.bind(this);
    this.boundNavigateBack = this.navigateBack.bind(this);

    this.init();
  }

  init() {
    // Login dropdown
    if (this.loginButton) {
      this.loginButton.addEventListener('mouseover', this.boundShowLoginDropdown);
      this.loginButton.addEventListener('mouseout', this.boundHideLoginDropdown);
    }

    // Full screen menu
    if (this.mobileButtons) {
      this.mobileButtons.forEach((mobileButton) => {
        mobileButton.addEventListener('click', this.boundToggleFullScreenMenu);
      });
    }
    if (this.backButton) {
      this.backButton.addEventListener('click', this.boundNavigateBack);
    }
    if (this.closeButton && this.openButton) {
      this.openButton.addEventListener('click', () => this.toggleVisibility(this.openButton, this.closeButton));
      this.closeButton.addEventListener('click', () => this.toggleVisibility(this.closeButton, this.openButton));
    }

    // Dropdown menu desktop en submenu mobile
    if (this.dropdownLinks) {
      this.dropdownLinks.forEach((dropdownLink) => {
        dropdownLink.addEventListener('mouseover', this.showDropdownMenu.bind(this, dropdownLink));
        dropdownLink.addEventListener('mouseleave', this.hideDropdownMenu.bind(this, dropdownLink));
        dropdownLink.addEventListener('click', this.showSubMenu.bind(this, dropdownLink));
      });
    }

    // Close full screen menu on link click
    if (this.menuLinks) {
      this.menuLinks.forEach((menuLink) => {
        menuLink.addEventListener('click', this.closeFullScreenMenuOnLinkClick.bind(this, menuLink));
      });
    }
  }

  destroy() {
    // Login dropdown
    this.loginButton.removeEventListener('click', this.boundHideLoginDropdown);
    this.loginButton.removeEventListener('mouseover', this.boundShowLoginDropdown);
    this.loginButton.removeEventListener('mouseout', this.boundHideLoginDropdown);

    // Full screen menu
    this.mobileButton.removeEventListener('click', this.boundToggleFullScreenMenu);
    this.backButton.removeEventListener('click', this.boundNavigateBack);

    // Dropdown menu desktop and submenu mobile
    this.dropdownLinks.forEach((dropdownLink) => {
      dropdownLink.removeEventListener('mouseover', this.showDropdownMenu.bind(this, dropdownLink));
      dropdownLink.removeEventListener('mouseleave', this.hideDropdownMenu.bind(this, dropdownLink));
      dropdownLink.removeEventListener('click', this.showSubMenu.bind(this, dropdownLink));
    });

    // Close full screen menu on link click
    this.menuLinks.forEach((menuLink) => {
      menuLink.removeEventListener('click', this.closeFullScreenMenuOnLinkClick.bind(this, menuLink));
    });
  }

  toggleVisibility(toggleElement, otherElement) {
    toggleElement.classList.toggle('visible');
    toggleElement.classList.toggle('hidden');
    otherElement.classList.toggle('visible');
    otherElement.classList.toggle('hidden');
  }

  hideLoginDropdown() {
    if (!this.loginDropdown) return;
    if (this.loginDropdown.classList.contains('hidden')) return;
    this.loginDropdown.classList.add('hidden');
  }

  showLoginDropdown() {
    if (!this.loginDropdown) return;
    if (!this.loginDropdown.classList.contains('hidden')) return;
    this.loginDropdown.classList.remove('hidden');
  }

  toggleFullScreenMenu() {
    this.fullScreenMenu.classList.toggle('hidden');
    this.navbar.classList.toggle('fixed');
    this.mobileButton.classList.toggle('close');
  }

  showDropdownMenu(dropdownLink) {
    dropdownLink.classList.add('active-link');

    const dropdownMenu = dropdownLink.querySelector('.dropdown-menu');
    dropdownMenu.classList.add('show-dropdown-menu');
    this.overlay.classList.add('show-overlay');

    const showDropdownMenus = document.querySelectorAll('.show-dropdown-menu');
    let dropdownMenusHeight = 0;
    showDropdownMenus.forEach((showDropdownMenu) => {
      if (dropdownMenusHeight < showDropdownMenu.offsetHeight) {
        dropdownMenusHeight = showDropdownMenu.offsetHeight;
      }
    });

    const menu = document.querySelector('.show-dropdown-menu');
    if (!menu) return;
    const background = menu.closest('.js-dropdown-menu');
    if (!background) return;
    if (dropdownMenusHeight < 1) return;
    background.style.height = `${dropdownMenusHeight}px`;
  }

  hideDropdownMenu(dropdownLink, event) {
    event.preventDefault();
    dropdownLink.classList.remove('active-link');

    const dropdownMenu = dropdownLink.querySelector('.dropdown-menu');
    if (dropdownMenu.classList.contains('js-dropdown-menu-child')) {
      dropdownMenu.classList.remove('show-dropdown-menu');
    } else {
      this.overlay.classList.remove('show-overlay');
    }
    this.dropdownLinksParents.forEach((dropdownLinksParent) => {
      const dropdownChild = dropdownLinksParent.querySelector('.dropdown-menu');
      dropdownChild.classList.remove('show-dropdown-menu');
    });
  }

  showSubMenu(dropdownLink) {
    const dropdownMenu = dropdownLink.querySelector('.dropdown-menu');
    dropdownMenu.classList.add('show-submenu');
    this.backButton.classList.add('show-back-button');
  }

  navigateBack(event) {
    event.preventDefault();
    const openMenus = document.querySelectorAll('.show-submenu');
    const lastOpenMenu = openMenus[openMenus.length - 1];
    lastOpenMenu.classList.remove('show-submenu');
    if (openMenus.length === 1) {
      this.backButton.classList.remove('show-back-button');
    }
  }

  closeFullScreenMenuOnLinkClick(menuLink) {
    if (!menuLink.classList.contains('menu-item-has-children')) {
      this.fullScreenMenu.classList.add('hidden');
      this.navbar.classList.remove('fixed');
      this.mobileButton.classList.remove('close');
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/navbar.js